import AppConfig from "../../../../app-config";
import { isDeviceMobile } from "../../../../libs/auth.helper";
export var SystemMessageTypes;
(function (SystemMessageTypes) {
    SystemMessageTypes["ADD_BOOKMARK"] = "50.500";
    SystemMessageTypes["POST_CALL"] = "50.501";
    SystemMessageTypes["ASK_FOR_PRICE"] = "50.502";
    SystemMessageTypes["ASK_FOR_DROP_PRICE"] = "50.503";
    SystemMessageTypes["ASK_FOR_IMAGE"] = "50.504";
    SystemMessageTypes["ASK_FOR_MAP"] = "50.506";
    SystemMessageTypes["APPLY_TO_JOB"] = "50.508";
    SystemMessageTypes["SIMILAR_ADS"] = "30.303";
    SystemMessageTypes["ASK_FOR_VIN"] = "50.505";
})(SystemMessageTypes || (SystemMessageTypes = {}));
export const SystemMessages = {
    [SystemMessageTypes.ADD_BOOKMARK]: {
        type: 50,
        subType: 500,
        text: {
            en: "I’ve added this listing to my favorites",
            ar: "أضفت الإعلان لقائمة الإعلانات المفضلة",
        },
        rich: { icon: "/stickers/fav.png" },
        slug: "add_bookmark",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.POST_CALL]: {
        type: 50,
        subType: 501,
        text: {
            en: "I checked the seller’s phone number",
            ar: "قُمتَ بإظهار رقم البائع",
        },
        rich: { icon: "/stickers/call.png" },
        slug: "post_call",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.ASK_FOR_PRICE]: {
        type: 50,
        subType: 502,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "I want to be notified if a price is added to this listing" : `${username} want to be notified if a price is added to this listing`;
                case 'ar':
                    return isSender ? "أريد أن اتلقى تنبيها اذا تم تحديد سعر لهذا الإعلان" : 'أن يتلقى تنبيها اذا تم تحديد سعر لهذا الإعلان ' + "\u200E" + username + "\u200E" + 'يريد';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForPrice.png",
        },
        slug: "ask_for_price",
        hasButtonSender: false,
        hasButtonReceiver: true,
        buttonText_sender_id: '',
        buttonText_receiver_id: 'ADD_PRICE',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'price_field' : 'priceStepLabelIdentifier';
            window.open(`${process.env.REACT_APP_ADD_POST}?v=2&source=${AppConfig.getConfig().authenticationData.source}&lang=${AppConfig.getConfig().lang}&flow=edit&draft_id=0&post_id=${message.pid}&return=${window.location.href}&scrollByIdentifier=${identifier}`, "blank");
        }
    },
    [SystemMessageTypes.ASK_FOR_DROP_PRICE]: {
        type: 50,
        subType: 503,
        text: {
            en: "I want to be notified if the price drops on this listing",
            ar: "أريد أن اتلقى تنبيها اذا تم تخفيض سعر هذا الإعلان",
        },
        rich: {
            icon: "/stickers/askForPrice.png",
        },
        slug: "ask_for_drop_price",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.ASK_FOR_IMAGE]: {
        type: 50,
        subType: 504,
        text: {
            en: "I asked to be notified when images are added to this listing",
            ar: "أريد أن اتلقى تنبيها اذا تمت إضافة صور لهذا الإعلان",
        },
        rich: {
            icon: "/stickers/askForImageChat.png",
        },
        slug: "ask_for_image",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.ASK_FOR_MAP]: {
        type: 50,
        subType: 506,
        text: {
            en: "I want to be notified if a map is added to this listing",
            ar: "أرسل لي تنبيها اذا تم تحديد الخريطة لهذا الإعلان",
        },
        rich: {
            icon: "/stickers/askForMap.png",
        },
        slug: "ask_for_map",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.APPLY_TO_JOB]: {
        type: 50,
        subType: 508,
        text: {
            en: "You have applied to this job",
            ar: "تم التقديم على الوظيفة",
        },
        rich: {
            icon: "/stickers/applyToJob.png",
        },
        slug: "apply_to_job",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.SIMILAR_ADS]: {
        type: 30,
        subType: 303,
        text: {
            en: "I’m interested",
            ar: "أنا مهتم",
        },
        slug: "similar_ads",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.ASK_FOR_VIN]: {
        type: 50,
        subType: 505,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? 'VIN Number request has been sent' : `${username} has requested to add VIN Number`;
                case 'ar':
                    return isSender ? 'تم إرسال طلب إضافة رقم الشاصي' : 'بإرسال طلب رقم الشاصي ' + "\u200E" + username + "\u200E" + ' قام';
            }
            return '';
        },
        slug: "add_vin_number",
        hasButtonSender: false,
        hasButtonReceiver: true,
        buttonText_sender_id: '',
        buttonText_receiver_id: 'ADD_VIN_NUMBER',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'vinNumber_fieldLabel' : 'vinNumber_field';
            window.open(`${process.env.REACT_APP_ADD_POST}?v=2&source=${AppConfig.getConfig().authenticationData.source}&lang=${AppConfig.getConfig().lang}&flow=edit&draft_id=0&post_id=${message.pid}&return=${window.location.href}&scrollByIdentifier=${identifier}`, "blank");
        }
    }
};
